import { useTheme, Box } from '@mui/material'
import React from 'react'

/*
 * Displays blank view for charts when no data is available
 */
const ChartBlankView: React.FC = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        height: '100%',
        backgroundColor: theme.palette.grey.grey06,
        maxHeight: 25,
        marginTop: 'auto',
        borderRadius: '0 0 6px 6px',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '2px',
          backgroundColor: theme.palette.grey.grey03,
          position: 'absolute',
          top: -2,
          left: 0,

          '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: theme.palette.common.white,
            border: `2px solid ${theme.palette.grey.grey03}`,
          },
        }}
      />
    </Box>
  )
}

export default ChartBlankView
